/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class BillingPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(billingPopup, profileDetails) {
    billingPopup.setAttribute(
      'univ-semantic-name',
      profileDetails.univSemanticname
    );

    billingPopup.setAttribute('view', profileDetails.view);
  }
}
